import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import GuestListView from "./guest-list.component.html";
import { GridConfig } from "../../../../shared/components/grid/models/grid-config.model";
import { EventGuest } from "../../../../shared/models/events/guests/event-guest.model";
import { LogService } from "../../../../core/services/log.service";
import { EventGuestsService } from "../../services/event-guests.service";
import { EventGuestAccreditation } from "../../../../shared/models/events/guests/event-guest-accreditation.model";
import { EventsService } from "../../services/events.service";
import { TranslateService, _ } from "@ngx-translate/core";
import { ContrastColorPipe } from "../../../../shared/pipes/contrast-color.pipe";
import { EventParking } from "../../../../shared/models/events/event-parking.model";
import { GuestGroupFullnamePipe } from "../../pipes/guest-group-fullname.pipe";
import { EventSpaceZone } from "../../../../shared/models/events/guests/event-space-zone.model";
import { EventGuestZone } from "../../../../shared/models/events/guests/event-guest-zone.model";
import { EventGuestDetails } from "../../../../shared/models/events/guests/event-guest-details.model";
import { NumericDataBarItem } from "../../../../shared/components/numeric-data-bar/models/numeric-data-bar-item.model";
import { EventSpace } from "../../../../shared/models/events/event-space.model";
import {
  SpaceOption,
  SpaceZoneFilterValue,
  ZoneFilterMetadata,
  ZonePlaceOption,
  ZonePlacesMap,
  buildZonePlaceKey,
  buildZonePlacesKey
} from "../../../../shared/models/events/space-zone-filter.model";
import { GridComponent } from "../../../../shared/components/grid/grid.component";
import { Event } from "../../../../shared/models/events/event.model";
import { ConfirmationService, FilterMetadata, FilterService, MessageService } from "primeng/api";
import { DocumentsService } from "../../../../shared/services/documents.service";
import { GridResponse } from "../../../../shared/models/common/grid-response.model";
import { DocumentGenerator } from "../../../../shared/models/documents/document-generator.model";
import { FileUpload, FileUploadErrorEvent, UploadEvent } from "primeng/fileupload";
import { HttpResponse } from "@angular/common/http";
import { PeopleService } from "../../../people/services/people.service";
import { Tag } from "../../../../shared/models/common/tag.model";
import { firstValueFrom } from "rxjs";
import { Mailing } from "../../../../shared/models/mailings/mailing.model";
import { GridColumn } from "../../../../shared/components/grid/models/grid-column.model";
import { EventGuestMailing } from "../../../../shared/models/events/guests/event-guest-mailing.model";
import { MailingGuestList } from "../../../../shared/models/events/guests/mailing-guest-list.model";

@Component({
  selector: "event-guest-list",
  template: GuestListView,
  styles: [
    ` .rowheader {
        font-size: 18px;
        font-weight: bold;
        padding: 10px 5px;
        width: 100%;
      }
      .guest-header-toolbar {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        flex-wrap: wrap;
      }
      .guest-header-search {
        width: 100%;
      }
      .guest-table-filters {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        flex-wrap: wrap;
        width: 100%;
      }
      .guest-advanced-filters {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        flex-wrap: wrap;
        padding: 0.25rem 0.5rem;
        border: 1px solid var(--p-surface-300);
        border-radius: 8px;
        background: var(--p-surface-50);
      }
      .guest-advanced-filter-item {
        min-width: 13rem;
      }
      .guest-filter-label {
        font-weight: 700;
      }
      :host ::ng-deep d-grid.guest-list-grid .p-datatable .p-datatable-tbody > tr > td {
        padding: 0.4rem 0.5rem;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      :host ::ng-deep d-grid.guest-list-grid .p-datatable .p-datatable-thead > tr:first-child > th > span {
        display: block;
      }
      :host ::ng-deep d-grid.guest-list-grid .p-datatable .p-datatable-thead > tr:first-child > th > span + span {
        margin-top: 0.25rem;
      }
      :host ::ng-deep d-grid.guest-list-grid .p-datatable .p-datatable-tbody > tr.guest-row-companion > td {
        background-color: #e9e9e9 !important;
      }
      :host ::ng-deep d-grid.guest-list-grid .p-datatable .p-datatable-tbody > tr.guest-row-companion > td.guest-col-mailing {
        background-color: #D8EAFA !important;
      }
      :host ::ng-deep d-grid.guest-list-grid .p-datatable .p-datatable-tbody > tr.guest-row-companion > td.guest-col-invitation {
        background-color: #E5F9CA !important;
      }
      :host ::ng-deep d-grid.guest-list-grid .p-datatable .p-datatable-tbody > tr.guest-row-delegated > td {
        background-color: lightyellow !important;
      }
      :host ::ng-deep d-grid.guest-list-grid .p-datatable .p-datatable-tbody > tr.guest-row-delegated > td.guest-col-mailing {
        background-color: #D8EAFA !important;
      }
      :host ::ng-deep d-grid.guest-list-grid .p-datatable .p-datatable-tbody > tr.guest-row-delegated > td.guest-col-invitation {
        background-color: #E5F9CA !important;
      }
      :host ::ng-deep d-grid.guest-list-grid .p-datatable .p-datatable-tbody > tr:hover > td.guest-col-mailing {
        background-color: #D8EAFA !important;
      }
      :host ::ng-deep d-grid.guest-list-grid .p-datatable .p-datatable-tbody > tr:hover > td.guest-col-invitation {
        background-color: #E5F9CA !important;
      }
      @media (max-width: 1366px) {
        .guest-header-search {
          min-width: 14rem;
        }
        .guest-advanced-filter-item {
          min-width: 11rem;
        }
      }
    `
  ]
})
export class GuestListComponent implements OnInit {
  @ViewChild("guestListGrid") private guestListGrid: GridComponent;
  @ViewChild("guestFullnameTemplate") private guestFullnameTemplate: TemplateRef<object>;
  @ViewChild("guestAccreditationTemplate") private guestAccreditationTemplate: TemplateRef<object>;
  @ViewChild("guestListGroupRowTemplate") private guestListGroupRowTemplate: TemplateRef<object>;
  @ViewChild("guestExpandedRowTemplate") private guestExpandedRowTemplate: TemplateRef<object>;
  @ViewChild("guestZoneInfoTemplate") private guestZoneInfoTemplate: TemplateRef<object>;
  @ViewChild("guestConfirmationStatusTemplate") private guestConfirmationStatusTemplate: TemplateRef<object>;
  @ViewChild("guestInvitationMailStatusTemplate") private guestInvitationMailStatusTemplate: TemplateRef<object>;
  @ViewChild("guestMailingStatusTemplate") private guestMailingStatusTemplate: TemplateRef<object>;
  @ViewChild("fu") private fu: FileUpload;
  @ViewChild("fu2") private fu2: FileUpload;

  gridConfig: GridConfig = {
    columns: [],
  };
  private allGridColumns: GridColumn[] = [];
  guests: EventGuest[] = [];
  filteredGuests: EventGuest[] = [];
  accreditations: EventGuestAccreditation[] = [];
  spaces: EventSpace[] = [];
  parkings: EventParking[] = [];
  zones: EventSpaceZone[] = [];
  numericDataBar: NumericDataBarItem[] = [];
  errorMessage: string = "";
  showError: boolean = false;
  documentActions: any[] = [];
  inviteActions: any[] = [];

  confirmationStatuses: any[] = [
    { id: "pending", name: this.translate.instant("events.guests.pending") },
    { id: "confirmed", name: this.translate.instant("events.guests.confirmed") },
    { id: "manage_delegate", name: this.translate.instant("events.guests.manage_delegate") },
    { id: "rejected", name: this.translate.instant("events.guests.rejected") },
    { id: "delegated", name: this.translate.instant("events.guests.delegated") },
    { id: "pending_approval", name: this.translate.instant("events.guests.pending_approval") }
  ];
  invitationMailStatuses: any[] = [
    { id: "unsent", name: this.translate.instant("events.guests.send_status_unsent") },
    { id: "print", name: this.translate.instant("events.guests.send_status_print") },
    { id: "mail", name: this.translate.instant("events.guests.send_status_mail") },
    { id: "inscription", name: this.translate.instant("events.guests.send_status_inscription") }
  ];
  mailingStatusFilterOptions: any[] = [
    { id: "unsent", name: this.translate.instant("events.guests.send_status_unsent") },
    { id: "sent_success", name: this.translate.instant("general.success") },
    { id: "sent_error", name: this.translate.instant("general.error") }
  ];

  totalGuests: number = 0;
  totalDelegated: number = 0;
  totalConfirmed: number = 0;
  totalRejected: number = 0;
  totalPending: number = 0;
  totalPendingApproval: number = 0;
  totalManageDelegate: number = 0;
  totalIncidents: number = 0;

  allowWrite: boolean = false;
  allowImport: boolean = false;
  allowUpdateImport: boolean = false;
  allowUserRead: boolean = false;
  eventId: number;
  tags: Tag[] = [];
  guestTags: Tag[] = [];
  mailings: Mailing[] = [];
  guestTagSet: Set<Tag> = new Set<Tag>();
  showOnlyWithoutPosition: boolean = false;
  showOnlyDirtyDetails: boolean = false;
  selectedTags: Tag[] = [];
  showAdvancedFilters: boolean = false;
  selectedGroupFilter: string[] = [];
  attachmentFilterMode: string = "all";
  groupFilterOptions: any[] = [];
  attachmentFilterOptions: any[] = [
    { id: "all", name: this.translate.instant("general.all") },
    { id: "sent", name: this.translate.instant("events.guests.communications_sent") },
    { id: "unsent", name: this.translate.instant("events.guests.no_attachment") },
  ];
  checkinFilterMode: string = "all";
  checkinFilterDate: Date | null = null;
  hasEventStarted: boolean = false;
  checkinFilterOptions: any[] = [
    { id: "all", name: this.translate.instant("general.all") },
    { id: "accessed", name: this.translate.instant("events.guests.checkin_filter_accessed") },
    { id: "not_accessed", name: this.translate.instant("events.guests.checkin_filter_not_accessed") },
    { id: "accessed_on_date", name: this.translate.instant("events.guests.checkin_filter_accessed_on_date") }
  ];
  zoneFilterMetadata: ZoneFilterMetadata = {
    spaces: [],
    zones: [],
    zonePlacesMap: {},
    spacePlaceholder: "events.spaces.select_space",
    zonePlaceholder: "events.spaces.select_zone",
    placePlaceholder: "events.spaces.select_place"
  };

  private event: Event = null;
  private zoneIdToSpaceId: Map<number, number | null> = new Map();
  private allGuests: EventGuest[] = [];
  private filteredItemsIds: number[] = [];
  private sortOption = 'events.spaces.sortbyname';
  private readonly gridStateStorageKey = "guestListTable";

  constructor(
    @Inject("$stateParams") private $stateParams: any,
    @Inject('$state') private $state: any,
    @Inject(EventGuestsService) private eventGuestsService: EventGuestsService,
    @Inject(DocumentsService) private documentsService: DocumentsService,
    @Inject(EventsService) private eventsService: EventsService,
    @Inject(LogService) private log: LogService,
    @Inject(TranslateService) private translate: TranslateService,
    @Inject(ContrastColorPipe) private contrastColorPipe: ContrastColorPipe,
    @Inject(GuestGroupFullnamePipe) private guestGroupFullnamePipe: GuestGroupFullnamePipe,
    @Inject('eventService') private eventService: any,
    @Inject('notificationService') private notificationService: any,
    @Inject (MessageService) private messageService: MessageService,
    @Inject(ConfirmationService) private confirmationService: ConfirmationService,
    @Inject('generateDocumentService') private generateDocumentService: any,
    @Inject('LoginService') private loginService: any,
    @Inject(PeopleService) private peopleService: PeopleService,
    @Inject(ChangeDetectorRef) private changeDetector: ChangeDetectorRef,
    @Inject(FilterService) private filterService: FilterService
  ) {
    this.eventId = this.$stateParams.id;
  }

  switchToLegacyView(): void {
    localStorage.setItem('guestListView', 'legacy');
    this.$state.go('events.edit.guests', {
      id: this.$stateParams.id,
      status: this.$stateParams.status,
      menu_item_id: this.$stateParams.menu_item_id
    });
  }

  ngOnInit() {
    const viewPref = localStorage.getItem('guestListView');
    if (viewPref === 'legacy') {
      this.switchToLegacyView();
      return;
    }

    this.allowWrite = this.loginService.permissionExist("EVENTS_GUESTS_WRITE");
    this.allowUserRead = this.loginService.permissionExist("USERS_READ");
    this.allowImport = this.loginService.permissionExist("PERSONS_IMPORT");
    this.allowUpdateImport = this.loginService.permissionExist("PERSONS_UPDATE_IMPORT");

    this.gridConfig.loading = true;

    this.filterService.register("guestWithoutPositionFilter", (value: EventGuest, filter: any): boolean => {
      if (!filter || !filter.value) return true;
      return !value.details.position || value.details.position.length === 0;
    });

    this.filterService.register("spaceZoneFilter", (value: SpaceZoneFilterValue[] | null, filter: FilterMetadata | SpaceZoneFilterValue | null): boolean => {
      const criteria = this.normalizeSpaceZoneFilterValue(filter);

      if (!criteria) {
        return true;
      }

      if (!value || value.length === 0) {
        return false;
      }

      const result = value.some(entry => this.matchesZoneCriteria(entry, criteria));
      return result;
    });

    this.eventsService.event$.subscribe(event => {
      this.event = event;
      this.updateEventStartState(event);
    });

    this.eventsService.getEvent(this.eventId).subscribe({
      next: (event) => {
        this.event = event;
        this.updateEventStartState(event);
      },
      error: (error) => {
        this.log.error("Error loading event", error);
      }
    });

    this.loadMalings();

    this.log.debug("Finished initializing guest list component");
  }

  private initializeGrid() {
    this.log.debug("Initializing guest list grid...");

    let columns: GridColumn[] = [
        {
          name: "name",
          header: { displayName: "events.guests.name" },
          template: this.guestFullnameTemplate,
          enableSorting: false,
          style: 'min-width: 200px;',
        },
        {
          name: 'FK_events_guests_events_parkings.name',
          header: { displayName: 'events.parking', style: 'max-width: 120px; white-space: nowrap;' },
          style: 'max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;',
          filter: {
            type: 'valueList',
            values: this.parkings,
            placeholder: 'events.parkings'
          }
        },
        {
          name: "zoneFilterValues",
          header: { displayName: "events.guests.zone", style: 'max-width: 130px; white-space: nowrap;' },
          template: this.guestZoneInfoTemplate,
          enableSorting: false,
          style: 'max-width: 130px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;',
          filter: {
            type: 'spaceZone',
            spaces: this.zoneFilterMetadata.spaces,
            zones: this.zoneFilterMetadata.zones,
            zonePlacesMap: this.zoneFilterMetadata.zonePlacesMap,
            spacePlaceholder: this.zoneFilterMetadata.spacePlaceholder,
            zonePlaceholder: this.zoneFilterMetadata.zonePlaceholder,
            placePlaceholder: this.zoneFilterMetadata.placePlaceholder
          }
        },
        {
          name: "event_guest_accreditation_id",
          header: { displayName: "events.guests.accreditation", style: 'max-width: 120px; white-space: nowrap;' },
          template: this.guestAccreditationTemplate,
          enableSorting: false,
          style: 'max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;',
          filter: {
            type: 'valueList',
            values: this.accreditations,
            placeholder: 'events.guests.accreditation'
          }
        },
      ];

      // Traverse mailings and add them as columns
      this.mailings.forEach((mailing: Mailing) => {
        const fieldName = this.getMailingFilterFieldName(mailing.id);
        columns.push({
          name: fieldName,
          header: { displayName: mailing.short_title, style: 'width: 1px; white-space: nowrap; background-color: #D8EAFA; border-color: var(--p-surface-300);'},
          style: 'width: 1px; white-space: nowrap; text-align: center; background-color: #D8EAFA; border-color: var(--p-surface-300);',
          cssClass: 'guest-col-mailing',
          template: this.guestMailingStatusTemplate,
          filter: {
            type: 'valueList',
            values: this.mailingStatusFilterOptions,
            placeholder: 'events.guests.status',
            matchMode: 'stringIn'
          }
        });
      });

        columns.push({
          name: "send_status",
          header: {
            displayName: "events.guests.send_invitation_short",
            style: "width: 1px; white-space: nowrap; text-align: center; background-color: #E5F9CA; border-color: var(--p-surface-300);",
          },
          style: "width: 1px; white-space: nowrap; text-align: center; background-color: #E5F9CA; border-color: var(--p-surface-300);",
          cssClass: 'guest-col-invitation',
          template: this.guestInvitationMailStatusTemplate,
          filter: {
            type: "valueList",
            values: this.invitationMailStatuses,
            placeholder: "events.guests.send_invitation_short",
            matchMode: "stringIn",
          },
        },
        {
          name: "confirmation_status",
          header: {
            displayName: "events.guests.status",
            style: "width: 1px; white-space: nowrap;",
          },
          template: this.guestConfirmationStatusTemplate,
          filter: {
            type: "valueList",
            values: this.confirmationStatuses,
            placeholder: "events.guests.status",
            matchMode: "stringIn",
          },
          style: "width: 1px; white-space: nowrap; text-align: center;",
        });

    this.allGridColumns = columns;
    this.gridConfig = {
      panelTitle: "events.guests.guests",
      columns: columns,
      actions: [
        {
          icon: "pi pi-refresh",
          severity: "warning",
          command: (row: EventGuest) => {
            this.syncGuestDetails(row);
          },
          size: "large",
          tooltip: this.translate.instant(_("events.guests.sync_dirty_details")),
          showCondition: (row: EventGuest) => !!row.dirtyDetails
        },
        {
          icon: "pi pi-cog",
          severity: "secondary",
          severityCallback: (row: EventGuest) => {
            if (this.isIndividualGuestMode(row)) {
              return 'secondary';
            }
            const pos = row?.details?.position;
            return (!pos || pos.trim() === '') ? 'danger' : 'secondary';
          },
          command: (row: EventGuest) => {
            this.eventService.configGuestModal(row, this.event ?? { id: this.eventId }, () => {
              this.loadGuests();
            });
          },
          size: "large",
          tooltip: this.translate.instant(_("events.guests.config")),
        }
      ],
      globalFilterFields: [
        "details.name",
        "details.surname",
        "details.lastname",
        "details.position",
        "details.groupFullname",
        "relatedSearchText",
      ],
      resizableColumns: false,
      stateStorage: "local",
      stateKey: this.getGridStateKey(),
      enableSelection: true,
      selectionCountPosition: 'top',
      dataKey: "id",
      showColumnSelector: true,
      showGlobalSearch: false,
      showClearButton: true,
      clearButtonTooltip: this.translate.instant('events.guests.clear_filters_tooltip'),
      showExportButton: true,
      exportType: "event_guests",
      exportOptions: {
        filters: {
          EVENT_ID: this.eventId,
          EXPORT_TYPE: "RESUME",
        },
        GUEST_LIST_INCLUDE_ACTS: true,
        FILTERED_IDS: this.filteredItemsIds,
      },
      showRefreshButton: true,
      refreshCallback: () => {
        this.loadGuests();
      },
      clearCallback: () => {
        //this.
        this.guestListGrid.selectedRows = [];
        this.selectedTags = [];
        this.showOnlyWithoutPosition = false;
        this.showOnlyDirtyDetails = false;
        this.selectedGroupFilter = [];
        this.attachmentFilterMode = "all";
        this.checkinFilterMode = "all";
        this.checkinFilterDate = null;
        this.applyTagFilter();
      },
      sortSelector: ["events.spaces.sortbyname", "events.spaces.prefered", "events.guests.groups"],
      sortSelectorPlaceholder: "events.spaces.orderby",
      sortSelectorCallback: (order: string) => {
        this.sortOption = order;
        this.sortGuests();
      },
      rowClickCallback: (row: EventGuest) => {
        this.eventService.configGuestModal(row, this.event ?? { id: this.eventId }, () => {
          this.loadGuests();
        });
      },

      rowClassCallback: (row: EventGuest) => this.getGuestRowClass(row),
      groupRowsBy: null,
      collapseGroupsByDefault: true,
      groupTemplate: this.guestListGroupRowTemplate,
//      enableRowExpand: true,
//      expandedRowTemplate: this.guestExpandedRowTemplate
      reorderableColumns: false,
      scrollable: true,
      scrollHeight: "calc(100vh - 100px)",
      paginator: false,
      virtualScroll: false,
      virtualScrollItemSize: 50,
      actionsLabel: "events.guests.actions",
      selectionActionItems: [
        {
          label: this.translate.instant(_("events.guests.button_parking")),
          icon: "pi pi-car",
          command: () => {
            this.massiveAction("parking");
          }
        },
        {
          label: this.translate.instant(_("events.guests.button_companions")),
          icon: "pi pi-users",
          command: () => {
            this.massiveAction("companions");
          }
        },
        {
          label: this.translate.instant(_("events.guests.desinvitar")),
          icon: "pi pi-times",
          command: () => {
            this.massiveAction("remove");
          }
        },
        {
          label: this.translate.instant(_("events.guests.button_accreditation")),
          icon: "pi pi-id-card",
          command: () => {
            this.massiveAction("accreditation");
          }
        },
        {
          label: this.translate.instant(_("events.programs_acts.button_masive_explicit_act")),
          icon: "pi pi-calendar",
          command: () => {
            this.massiveAction("acts");
          }
        },
        {
          label: this.translate.instant(_("events.guests.assign_annexes")),
          icon: "pi pi-list",
          command: () => {
            this.massiveAction("annexes");
          }
        },
        {
          label: this.translate.instant(_("events.guests.assign_spaces")),
          icon: "pi pi-map",
          command: () => {
            this.massiveAction("spaces");
          }
        },
        {
          label: this.translate.instant(_("events.work_team.send_mail_all_new")),
          icon: "pi pi-envelope",
          command: () => {
            this.massiveAction("sendMail");
          },
          showCondition: () => {
            return this.allowWrite;
          }
        },
        {
          label: this.translate.instant(_("events.guests.confirm_selected")),
          icon: "pi pi-list-check",
          command: () => {
            this.massiveAction("confirm");
          }
        },
        {
          label: this.translate.instant(_("events.guests.sync_dirty_details_selected")),
          icon: "pi pi-refresh",
          command: () => {
            this.syncSelectedGuestDetails();
          }
        },
      ],
      selectionItemsOnPanelHeader: true
      ,
      filterPrefixRules: [
        {
          prefix: "mailing_",
          matchMode: "stringIn"
        }
      ]
    };

    this.updateColumnVisibility();
  }

  private updateColumnVisibility() {
    if (!this.gridConfig || !this.allGridColumns.length) return;
    let hiddenColumns = [];
    const hasParking = this.allGuests.some(g => g.FK_events_guests_events_parkings != null);
    if (!hasParking) {
      hiddenColumns.push("FK_events_guests_events_parkings.name");
    }

    const hasAccreditation = this.allGuests.some(g => g.event_guest_accreditation_id != null);
    if (!hasAccreditation) {
      hiddenColumns.push("event_guest_accreditation_id");
    }

    const hasZone = this.allGuests.some(g =>
      g.zoneFilterValues && g.zoneFilterValues.length > 0 && g.zoneFilterValues.some(z => z.zoneId != null)
    );
    if (!hasZone) {
      hiddenColumns.push("zoneFilterValues");
    }
    // Reassign gridConfig with a fresh columns array so the grid's config setter
    // fires and re-processes hiddenColumns from scratch (the setter splices columns
    // in-place, so reusing the same reference would permanently lose them).
    this.gridConfig = { ...this.gridConfig, columns: [...this.allGridColumns], hiddenColumns };
  }

  private loadTags() {
    this.peopleService.getTags().subscribe({
      next: (response) => {
        this.tags = response;
        //  let noTag = { id: 0, checked: false};
        this.tags.unshift({
          id: 0,
          title: null,
          description: null,
          company_id: null,
          entity_type: null,
          color: null,
          icon: null,                
        });;
        this.loadGuests();
      },
      error: (error) => {
        this.log.error("Error loading tags", error);
      }
    });
  }

  private getGroupFilterValues() {
    const groups = this.allGuests
      .map(g => g?.details?.groupFullname)
      .filter((value): value is string => !!value && value.trim().length > 0);

    const unique = Array.from(new Set(groups)).sort((a, b) => a.localeCompare(b));
    return unique.map(group => ({ id: group, name: group }));
  }

  private attachRelatedGuests() {
    const byPersonId = new Map<number, EventGuest>();
    this.allGuests.forEach(guest => {
      if (guest.person_id != null) {
        byPersonId.set(guest.person_id, guest);
      }
      guest.relatedGuests = [];
      guest.relatedSearchText = "";
    });

    this.allGuests.forEach(guest => {
      if (guest.referrer_person_id == null) {
        return;
      }
      const parent = byPersonId.get(guest.referrer_person_id);
      if (!parent) {
        return;
      }
      parent.relatedGuests?.push(guest);
      const parentDetails = this.ensureGuestDetails(parent);
      guest.referrerFullname = `${parentDetails.surname || ''}${parentDetails.lastname ? ' ' + parentDetails.lastname : ''}, ${parentDetails.name || ''}`.trim();
    });

    this.allGuests.forEach(guest => {
      if (!guest.relatedGuests || guest.relatedGuests.length === 0) {
        return;
      }

      guest.relatedSearchText = guest.relatedGuests
        .map(child => {
          const details = this.ensureGuestDetails(child);
          return `${details.surname || ""} ${details.lastname || ""} ${details.name || ""}`.trim();
        })
        .join(" ");

      const companionList = guest.relatedGuests
        .filter(child => child.referred_option !== 'delegated')
        .map(child => {
          const details = this.ensureGuestDetails(child);
          return `${details.surname || ''}${details.lastname ? ' ' + details.lastname : ''}, ${details.name || ''}`.trim();
        });
      guest.companionNames = companionList.join(', ');
    });
  }

  private normalizeGuestReferralRelations(guests: EventGuest[]): void {
    const byPersonId = new Map<number, EventGuest>();
    guests.forEach(guest => {
      if (guest?.person_id != null) {
        byPersonId.set(guest.person_id, guest);
      }
    });

    guests.forEach(guest => {
      if (guest?.referrer_person_id == null) {
        return;
      }

      const parent = byPersonId.get(guest.referrer_person_id);
      const option = (guest.referred_option || '').toString().trim().toLowerCase();
      const referredIn = (guest.referred_in || '').toString().trim().toLowerCase();

      const delegatedByOption = option.includes('deleg');
      const delegatedByText = referredIn.includes('deleg');
      const delegatedByParent = parent?.confirmation_status === 'delegated';

      if (delegatedByOption || delegatedByText || delegatedByParent) {
        guest.referred_option = 'delegated';
      } else if (!option) {
        guest.referred_option = 'companion';
      }
    });
  }

  private orderGuestsWithRelated(guests: EventGuest[]): EventGuest[] {
    // Build a map from person_id -> guest (referrer_person_id references person_id, not guest id)
    const byPersonId = new Map<number, EventGuest>();
    guests.forEach(guest => {
      if (guest.person_id != null) {
        byPersonId.set(guest.person_id, guest);
      }
    });

    // Separate parents (no referrer) from children
    const parents: EventGuest[] = [];
    const childrenByParentPersonId = new Map<number, EventGuest[]>();
    const orphans: EventGuest[] = [];

    guests.forEach(guest => {
      if (guest.referrer_person_id == null) {
        parents.push(guest);
        return;
      }
      // Check if the parent is in the current list
      const parent = byPersonId.get(guest.referrer_person_id);
      if (parent) {
        const siblings = childrenByParentPersonId.get(guest.referrer_person_id) || [];
        siblings.push(guest);
        childrenByParentPersonId.set(guest.referrer_person_id, siblings);
      } else {
        orphans.push(guest);
      }
    });

    // Build ordered list: each parent followed by its children
    const ordered: EventGuest[] = [];
    const seen = new Set<number>();

    parents.forEach(parent => {
      if (seen.has(parent.id)) return;
      ordered.push(parent);
      seen.add(parent.id);

      const children = childrenByParentPersonId.get(parent.person_id) || [];
      children.forEach(child => {
        if (!seen.has(child.id)) {
          ordered.push(child);
          seen.add(child.id);
        }
      });
    });

    orphans.forEach(guest => {
      if (!seen.has(guest.id)) {
        ordered.push(guest);
        seen.add(guest.id);
      }
    });

    // Safety: include any guests not yet added
    guests.forEach(guest => {
      if (!seen.has(guest.id)) {
        ordered.push(guest);
        seen.add(guest.id);
      }
    });

    return ordered;
    
  }

  private addInviteActions() {
    this.inviteActions = []

    if(this.allowWrite) {
      this.inviteActions.push({
        label: _(this.translate.instant("events.guests.button_add_masive")),
        icon: "pi pi-search",
        command: () => {
          this.eventService.searchMassiveGuestModal(this.eventId, () => {
            this.loadGuests();
          });
        }
      });
    }
    this.inviteActions.push({
      label: _(this.translate.instant("events.guests.button_add_group")),
      icon: "pi pi-search-plus",
      command: () => {
        this.eventService.searchGroups(this.eventId, () => {
          this.loadGuests();
        });
      }
    });

    if (this.allowWrite) {
      this.inviteActions.push({
        label: _(this.translate.instant("events.guests.button_add_guest")),
        icon: "pi pi-id-card",
        command: () => {
          this.eventService.addGuestDialog(this.eventId, () => {
            this.loadGuests();
          });
        }
      });
    }

    if(this.allowImport) {
      this.inviteActions.push({
        label: _(this.translate.instant("persons.button_import")),
        icon: "pi pi-users",
        command: () => {
          this.fu.basicFileInput.nativeElement.click();
        }
      });
    }

    if(this.allowUpdateImport) {
      this.inviteActions.push({
        label: this.translate.instant("events.guests.button_update_csv"),
        icon: "pi pi-file-edit",
        command: () => {
          this.fu2.basicFileInput.nativeElement.click();
        }
      });
    }
  }

  private loadDocuments() {
    this.log.debug("Loading documents for guest list...");
    let codes = ["GUEST_LIST", "PROPOSAL_GUEST_LIST", "PROGRAM_ACTS", "GUEST_ACCREDITATION", "GUEST_LIST_ADDRESSES", "GUEST_PARKING", "INVITATION", "SEATING", "CERTIFICATES", "PROTOCOL_NOTES", "EVENT_MENU"]
    this.documentsService.getDocumentsByCode(codes).subscribe((response) => {
      let documentTypes = response.rows.map(function (item) {
          return {
              code: item.FK_documents_documents_types.code,
              name: item.FK_documents_documents_types.name,
              icon: item.FK_documents_documents_types.icon
          };
        }).filter(function (x, i, a) {
          return a.findIndex(m => m.code === x.code) == i;
        });

      this.documentActions = documentTypes.map((docType) => {
        return {
          icon: docType.icon,
          label: docType.name,
          command: () => {
            this.showPrintModal(docType.code);
          }
        };
      });

      this.loadAccreditations();

    });
  }

  private loadAccreditations() {
    this.log.debug("Loading accreditations for guest list...");
    this.eventsService.getAccreditations(this.eventId).subscribe({
      next: (accreditations) => {
        this.accreditations = accreditations;
        this.accreditations.unshift({
          id: null,
          name: this.translate.instant("events.guests.no_accreditation"),                  
          event_id: null,
          company_id: null,
          color: null,
          nameNormalized: null,
        });
        this.loadParkings();
      },
      error: (error) => {
        this.log.error("Error loading accreditations", error);
        this.accreditations = [];
        this.loadParkings();
      }
    });
  }

  private loadParkings() {
    this.log.debug("Loading parkings for guest list...");
    this.eventsService.getParkings(this.eventId).subscribe({
      next: (parkings) => {
        this.parkings = parkings;
        this.parkings.unshift({
          id: null,
          name: this.translate.instant("events.guests.no_parking"),                  
          event_id: null,
          image_id: null,
          fK_events_parkings_images: null,
          image: null
        });
        this.loadSpaces();
      }, error: (error) => {
          this.log.error('Error loading parkings', error);
          this.parkings = [];
          this.loadSpaces(); 
          }
      
    });
  }

  private loadSpaces() {
    this.log.debug("Loading spaces for guest list...");
    this.eventsService.getSpaces(this.eventId).subscribe({
      next: (spaces) => {
        this.spaces = spaces;
        this.loadZones();
      },
      error: (error) => {
        this.log.error("Error loading spaces", error);
        this.spaces = [];
        this.loadZones();
      }
    });
  }

  private loadZones() {
    this.log.debug("Loading zones for guest list...");
    this.eventsService.getZones(this.eventId).subscribe({
      next: (zones) => {
        this.zones = zones;
        this.zones.unshift({
          id: null,
          name: "Sin zona",
          type: "none",
          code: "none",
          x: null,
          y: null,
          width: null,
          height: null,
          configuration: null,
          fK_events_spaces_zones_events_spaces: null,
        });
        this.buildZoneFilterMetadata();
        this.loadTags();
      }
    });
  }

  private buildZoneFilterMetadata() {
    const spacesMap: Map<number, SpaceOption> = new Map();
    const zonePlacesMap: ZonePlacesMap = {};

    // Clear and rebuild the zoneIdToSpaceId map
    this.zoneIdToSpaceId.clear();

    this.spaces.forEach(space => {
      if (space?.id !== undefined && space?.id !== null) {
        spacesMap.set(space.id, { id: space.id, name: space.name });
      }
    });

    this.zones.forEach(zone => {
      const spaceId = this.getSpaceIdFromZone(zone);
      const space = zone.fK_events_spaces_zones_events_spaces;
      
      // Map zone ID to space ID
      if (zone.id !== null && zone.id !== undefined) {
        this.zoneIdToSpaceId.set(zone.id, spaceId ?? null);
      }
      
      if (spaceId !== null && spaceId !== undefined && !spacesMap.has(spaceId)) {
        const resolvedName = space?.name ?? this.spaces.find(current => current.id === spaceId)?.name;
        if (resolvedName) {
          spacesMap.set(spaceId, { id: spaceId, name: resolvedName });
        }
      }

      if (zone.configuration) {
        try {
          const config = JSON.parse(zone.configuration);
          const entries = Array.isArray(config) ? config : config?.places;
          if (entries && Array.isArray(entries)) {
            const options = entries
              .map((place: any) => {
                const placeKey = buildZonePlaceKey(zone.id, place.file, place.position);
                if (!placeKey) {
                  return null;
                }
                return {
                  key: placeKey,
                  label: [
                    place.file ? `${this.translate.instant('events.guests.row')} ${place.file}` : null,
                    place.position ? `${this.translate.instant('events.guests.seat')} ${place.position}` : null
                  ].filter(Boolean).join(' - ')
                };
              })
              .filter((option): option is ZonePlaceOption => option !== null);

            if (options.length > 0) {
              zonePlacesMap[buildZonePlacesKey(zone.id)] = options;
            }
          }
        } catch (error) {
          this.log.error('Error parsing zone configuration', error);
        }
      }
    });

    this.zoneFilterMetadata = {
      spaces: [{ id: null, name: this.translate.instant('events.spaces.all_spaces') }, ...Array.from(spacesMap.values())],
      zones: this.zones,
      zonePlacesMap,
      spacePlaceholder: 'events.spaces.select_space',
      zonePlaceholder: 'events.spaces.select_zone',
      placePlaceholder: 'events.spaces.select_place'
    };
  }

  private getSpaceIdFromZone(zone: EventSpaceZone): number | null {
    return zone.fK_events_spaces_zones_events_spaces?.id ?? zone.event_space_id ?? null;
  }

  onSelectedTagsChange(selectedTags: Tag[]) {
    this.selectedTags = selectedTags;
    this.applyTagFilter();
  }

  private applyTagFilter() {
    if (this.selectedTags.length === 0) {
      // No tags selected, show all guests (respecting other filters)
      this.filteredGuests = [...this.allGuests];
    } else {
      // Filter guests that have at least one of the selected tags
      const selectedTagIds = this.selectedTags.map(t => t.id);
      this.filteredGuests = this.allGuests.filter(guest => {
        if (!guest.Tags || guest.Tags.length === 0) {
          return false;
        }
        return guest.Tags.some(tag => selectedTagIds.includes(tag.id));
      });
    }

    // Apply incidence filter: show only group-type guests without assigned position
    if (this.showOnlyWithoutPosition) {
      this.filteredGuests = this.filteredGuests.filter(
        guest => this.hasGuestPositionIncident(guest)
      );
    }

    if (this.showOnlyDirtyDetails) {
      this.filteredGuests = this.filteredGuests.filter(guest => !!guest.dirtyDetails);
    }

    if (this.selectedGroupFilter.length > 0) {
      const selectedGroups = new Set(this.selectedGroupFilter);
      this.filteredGuests = this.filteredGuests.filter(guest => {
        const groupName = guest?.details?.groupFullname;
        return !!groupName && selectedGroups.has(groupName);
      });
    }

    if (this.attachmentFilterMode !== "all") {
      this.filteredGuests = this.filteredGuests.filter(guest => this.matchesAttachmentFilter(guest));
    }

    if (this.checkinFilterMode !== "all") {
      this.filteredGuests = this.filteredGuests.filter(guest => this.matchesCheckinFilter(guest));
    }

    this.loadGuestData();
    this.gridConfig.unfilteredTotal = this.allGuests.length;
    this.sortGuests();
  }

  public onCheckinFilterModeChange(mode: string) {
    this.checkinFilterMode = mode || "all";
    if (this.checkinFilterMode !== "accessed_on_date") {
      this.checkinFilterDate = null;
    }
    this.applyTagFilter();
  }

  public onCheckinFilterDateChange() {
    if (this.checkinFilterMode === "accessed_on_date") {
      this.applyTagFilter();
    }
  }

  public onAdvancedFiltersToggle() {
    this.showAdvancedFilters = !this.showAdvancedFilters;
  }

  public onAdvancedFiltersChange() {
    this.applyTagFilter();
  }

  private matchesAttachmentFilter(guest: EventGuest): boolean {
    const status = guest?.send_status;
    const isSent = status != null && status !== "" && status !== "unsent";

    if (this.attachmentFilterMode === "sent") {
      return isSent;
    }

    if (this.attachmentFilterMode === "unsent") {
      return !isSent;
    }

    return true;
  }

  private matchesCheckinFilter(guest: EventGuest): boolean {
    const hasCheckin = !!guest?.check_in_date;

    switch (this.checkinFilterMode) {
      case "accessed":
        return hasCheckin;
      case "not_accessed":
        return !hasCheckin;
      case "accessed_on_date":
        if (!this.checkinFilterDate) {
          return true;
        }
        return this.normalizeDateOnly(guest?.check_in_date) === this.normalizeDateOnly(this.checkinFilterDate);
      case "all":
      default:
        return true;
    }
  }

  private normalizeDateOnly(value: string | Date | null | undefined): string | null {
    if (!value) {
      return null;
    }

    const dateValue = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(dateValue.getTime())) {
      return null;
    }

    const year = dateValue.getFullYear();
    const month = String(dateValue.getMonth() + 1).padStart(2, "0");
    const day = String(dateValue.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  private updateEventStartState(event: Event | null) {
    this.hasEventStarted = this.isEventStarted(event);
  }

  private isEventStarted(event: Event | null): boolean {
    if (!event?.date_from) {
      return false;
    }

    const startDate = new Date(event.date_from);
    if (Number.isNaN(startDate.getTime())) {
      return false;
    }

    return startDate.getTime() <= Date.now();
  }

  private loadMalings() {

    this.eventsService.getMailings(this.eventId).subscribe({
      next: (mailings) => {
        this.mailings = mailings;
        this.addInviteActions();

        this.loadDocuments()
      },
      error: (error) => {
        this.log.error("Error loading mailings", error);
        this.mailings = [];
      }
    });    
  }

  massiveAction(action: string) {
    if(this.guestListGrid.selectedRows.length === 0) {
      this.showError = true;
      this.errorMessage = this.translate.instant(_("events.guests.select_persons"));
      return;
    }

    let guestIds = this.guestListGrid.selectedRows.map((guest: EventGuest) => guest.id);
    const currentEvent = this.getCurrentEventContext();

    switch (action) {
      case "parking":
        this.eventService.assignParking(currentEvent, guestIds, (parkingOptions: { parking_id: number, allow_parking: boolean, max_vehicles: number }) => {
          this.messageService.add({ severity: 'success', key: 'topright', summary: this.translate.instant('general.success'), detail: this.translate.instant('events.guests.action_success') });
          // Locally update affected guests instead of a full server reload.
          // The AngularJS service now passes the chosen parking options back to this callback.
          const assignedParking = this.parkings.find(p => p.id === parkingOptions.parking_id) ?? null;
          const guestIdSet = new Set(guestIds);
          this.allGuests.forEach((guest: EventGuest) => {
            if (!guestIdSet.has(guest.id)) return;
            guest.FK_events_guests_events_parkings = assignedParking;
            guest.allow_parking = parkingOptions.allow_parking;
            guest.num_vehicles = parkingOptions.max_vehicles;
          });
          this.guestListGrid.selectedRows = [];
          this.updateColumnVisibility();
          this.applyTagFilter();
        });
        break;
      case "zone":
        this.eventService.assignZone(currentEvent, guestIds, (zoneOption: { zone: string, companions_zone: string }) => {
          this.messageService.add({ severity: 'success', key: 'topright', summary: this.translate.instant('general.success'), detail: this.translate.instant('events.guests.action_success') });
          // Locally update affected guests instead of a full server reload.
          // The AngularJS service now passes the chosen zone option back to this callback.
          // zone === "" or zone === "-1" means no zone (cleared); otherwise it is the zone name string.
          const zoneName = (zoneOption.zone === "-1" || zoneOption.zone == null) ? "" : zoneOption.zone;
          const guestIdSet = new Set(guestIds);
          this.allGuests.forEach((guest: EventGuest) => {
            if (!guestIdSet.has(guest.id)) return;
            guest.zone = zoneName;
            // Recompute the space-zone filter values for this guest since zone data changed.
            const zones = Array.isArray(guest.FK_events_guests_zones_events_guests)
              ? guest.FK_events_guests_zones_events_guests
              : [];
            guest.zoneFilterValues = this.buildGuestZoneFilterValues(zones);
          });
          this.guestListGrid.selectedRows = [];
          this.updateColumnVisibility();
          this.applyTagFilter();
        });
        break;
      case "companions":
        // Handle companions action
        this.eventService.setCompanionLimit(currentEvent, guestIds, () => {
          this.messageService.add({ severity: 'success', key: 'topright', summary: this.translate.instant('general.success'), detail: this.translate.instant('events.guests.action_success') });
          this.guestListGrid.selectedRows = [];
          this.loadGuests();
        });
        break;
      case "remove":
        // Handle remove action
        this.eventService.massiveRemove(currentEvent, this.guestListGrid.selectedRows, () => {
          this.messageService.add({ severity: 'success', key: 'topright', summary: this.translate.instant('general.success'), detail: this.translate.instant('events.guests.action_success') });
          this.guestListGrid.selectedRows = [];
          this.loadGuests();
        });
        break;
      case "accreditation":
        this.eventService.assignAccreditation(currentEvent, guestIds, (accreditationOption: { event_guest_accreditation_id: number }) => {
          this.messageService.add({ severity: 'success', key: 'topright', summary: this.translate.instant('general.success'), detail: this.translate.instant('events.guests.action_success') });
          this.guestListGrid.selectedRows = [];
          this.loadGuests();
        });
        break;
      case "acts":
        // Handle acts action
        this.eventService.assignActs(currentEvent, guestIds, () => {
          this.messageService.add({ severity: 'success', key: 'topright', summary: this.translate.instant('general.success'), detail: this.translate.instant('events.guests.action_success') });
          this.guestListGrid.selectedRows = [];
          this.loadGuests();
        });
        break;
      case "annexes":
        // Handle annexes action
        this.eventService.assignAnnexes(currentEvent, guestIds, () => {
          this.messageService.add({ severity: 'success', key: 'topright', summary: this.translate.instant('general.success'), detail: this.translate.instant('events.guests.action_success') });
          this.guestListGrid.selectedRows = [];
          this.loadGuests();
        });
        break;
      case "spaces":
        // Handle spaces action
        this.eventService.assignSpaces(currentEvent, guestIds, () => {
          this.messageService.add({ severity: 'success', key: 'topright', summary: this.translate.instant('general.success'), detail: this.translate.instant('events.guests.action_success') });
          this.guestListGrid.selectedRows = [];
          this.loadGuests();
        });
        break;
      case "confirm":
        // Handle confirm action
        this.eventService.confirmSelected(currentEvent, this.guestListGrid.selectedRows, () => {
          this.messageService.add({ severity: 'success', key: 'topright', summary: this.translate.instant('general.success'), detail: this.translate.instant('events.guests.action_success') });
          this.guestListGrid.selectedRows = [];
          this.loadGuests();
        });
        break;
      case "sendMail":
        this.sendMailToGuests();
        break;
    }
  }

  getGroupSyle(rowData: any) {
    var color = rowData.color;
    if(rowData.groupTree != null) {
      color = rowData.groupTree[rowData.groupTree.length - 1].color;
    }
    return "'background-color': " + color + "; 'color': " + this.contrastColorPipe.transform(color) + ";";
  }

  sendMailToGuests() {
    if(this.guestListGrid.selectedRows.length === 0) {
      this.showError = true;
      this.errorMessage = this.translate.instant(_("events.guests.select_persons"));
      return;
    }

    const currentEvent = this.getCurrentEventContext();

    if (currentEvent.mail_account_id == null || currentEvent.mail_account_id == 0) {
      this.showError = true;
      this.errorMessage = this.translate.instant(_("events.select_mail_from_address"));
      return;
    }

    let guestsIds = this.guestListGrid.selectedRows.map((guest: EventGuest) => guest.id);

    const params = {
      entity_type: "events",
      entity_type_id: this.eventId,
      event_guests_ids: guestsIds,
      mail_account_id: currentEvent.mail_account_id,
      mail_account_reply: currentEvent.reply_to,
      documents: {for_event_guest: true}
    };

    this.notificationService.notificationMail({
        params: params,
        onAccept: (data) => {
          this.messageService.add({ severity: 'success', key: 'topright', summary: this.translate.instant('general.success'), detail: this.translate.instant('notifications.sending_mail_success') });
        }
    });
  }

  private sortGuests() {
    this.gridConfig.groupRowsBy = null;
    if (this.sortOption === "events.spaces.prefered") {
      this.filteredGuests.sort((a, b) => {
        return this.sortGuestByPreferred(a, b);
      });
    } else if (this.sortOption === "events.spaces.sortbyname") {
      this.filteredGuests.sort((a, b) => {
        return this.sortGuestByName(a, b);
      });
    } else if (this.sortOption === "events.guests.groups") {
      this.gridConfig.groupRowsBy = "details.groupFullname";
      this.filteredGuests.sort((a, b) => {
        return this.sortByGroups(a, b);
      });
      if (this.guestListGrid) {
        this.guestListGrid.expandedGroupRows = {};
      }
      return;
    }
    // Re-apply parent → child grouping after sort
    this.filteredGuests = this.orderGuestsWithRelated(this.filteredGuests);
  }

  private getGuestRowClass(row: EventGuest): string {
    if (row?.referrer_person_id != null) {
      return "guest-row-companion";
    }

    if (row?.confirmation_status === "delegated") {
      return "guest-row-delegated";
    }

    return "";
  }

  private sortGuestByPreferred(a: EventGuest, b: EventGuest): number {
    if (
      a.details.effectivePositionOrder == null &&
      b.details.effectivePositionOrder == null
    ) {
      return 0;
    }
    if (b.details.effectivePositionOrder == null) {
      return -1;
    }
    if (a.details.effectivePositionOrder == null) {
      return 1;
    }
    if(a.details.effectivePositionOrder == b.details.effectivePositionOrder) {
      return this.sortGuestByName(a, b);
    }
    return a.details.effectivePositionOrder - b.details.effectivePositionOrder;
  }

  private sortGuestByName(a: EventGuest, b: EventGuest): number {
      const aName = a.details.surname + " " + a.details.lastname + " " + a.details.name;
      const bName = b.details.surname + " " + b.details.lastname + " " + b.details.name;
      return aName.localeCompare(bName);
  }

  private sortByGroups(a: EventGuest, b: EventGuest): number {
    if(a.details.group1Position == null && b.details.group1Position == null) {
      return this.sortByGroupNames(a, b);
    }

    if(a.details.group1Position == null) {
      return 1;
    }
    if(b.details.group1Position == null) {
      return -1;
    }

    if(a.details.group1Position != b.details.group1Position) {
      return a.details.group1Position - b.details.group1Position;
    }

    if(a.details.group2Position == null && b.details.group2Position == null) {
        return this.sortByGroupNames(a, b);
    }

    if(a.details.group2Position == null) {
      return 1;
    }
    if(b.details.group2Position == null) {
      return -1;
    }
    if(a.details.group2Position != b.details.group2Position) {
      return a.details.group2Position - b.details.group2Position;
    }
    if(a.details.group3Position == null && b.details.group3Position == null) {
      return this.sortByGroupNames(a, b);
    }
    if(a.details.group3Position == null) {
      return 1;
    }
    if(b.details.group3Position == null) {
      return -1;
    }
    if(a.details.group3Position != b.details.group3Position) {
      return a.details.group3Position - b.details.group3Position;
    }
    if(a.details.group4Position == null && b.details.group4Position == null) {
      return this.sortByGroupNames(a, b);
    }
    if(a.details.group4Position == null) {
      return 1;
    }
    if(b.details.group4Position == null) {
      return -1;
    }
    if(a.details.group4Position != b.details.group4Position) {
      return a.details.group4Position - b.details.group4Position;
    }
    
    if(a.details.group5Position == null && b.details.group5Position == null) {
      return this.sortByGroupNames(a, b);
    }

    if(a.details.group5Position == null) {
      return 1;
    }
    if(b.details.group5Position == null) {
      return -1;
    }
    if(a.details.group5Position != b.details.group5Position) {
      return a.details.group5Position - b.details.group5Position;
    }
    if(a.details.group6Position == null && b.details.group6Position == null) {
      return this.sortByGroupNames(a, b);
    }
    if(a.details.group6Position == null) {
      return 1;
    }
    if(b.details.group6Position == null) {
      return -1;
    }
    if(a.details.group6Position != b.details.group6Position) {
      return a.details.group6Position - b.details.group6Position;
    }
    // If all group positions are equal, sort by group names
    if(a.details.group1Name != null && b.details.group1Name != null) {
      return this.sortByGroupNames(a, b);
    }

    return this.sortGuestByPreferred(a, b);
  }

  private sortByGroupNames(a: EventGuest, b: EventGuest): number {
    if(b.details.group1Name == null) {
      return -1;
    }
    if(a.details.group1Name == null) {
      return 1;
    }
    const aGroup = a.details.group1Name  + " " + a.details.group2Name + " " + a.details.group3Name + " " + a.details.group4Name + " " + a.details.group5Name + " " + a.details.group6Name;
    const bGroup = b.details.group1Name  + " " + b.details.group2Name + " " + b.details.group3Name + " " + b.details.group4Name + " " + b.details.group5Name + " " + b.details.group6Name;
    return aGroup.localeCompare(bGroup);
  }

  private async loadGuests() {
    this.gridConfig.loading = true;
    this.eventGuestsService.getAll(this.eventId).subscribe({
      next: (guests: EventGuest[]) => {
        let guestsWithoutPosition = false;
        let mailingIds = new Set<number>();
        this.guestTagSet = new Set<Tag>();
        // Apply group fullname pipe to each guest details
        this.allGuests = guests.map((guest: EventGuest) => {
          const details = this.ensureGuestDetails(guest);

          if ((!details.position || details.position.trim() === "") && guest.position) {
            details.position = guest.position;
          }

          if (this.isIndividualGuestMode(guest) && this.isEmptyOrNotPositionLabel(details.position)) {
            // Individual mode guests can legitimately have no position,
            // so avoid showing placeholder labels like "Sin cargo".
            details.position = "";
          }
          if (!details.institution && (guest as any).institution) {
            details.institution = (guest as any).institution;
          }
          if (!details.group1Name && (guest as any).group_name) {
            details.group1Name = (guest as any).group_name;
          }
          if ((!details.tags || details.tags.trim() === "") && (guest as any).tags) {
            details.tags = String((guest as any).tags);
          }

          details.groupFullname = this.guestGroupFullnamePipe.transform(details);
          details.groupColor = details.groupColor != "" ? details.groupColor : "lightgray";
          const zones = Array.isArray(guest.FK_events_guests_zones_events_guests)
            ? guest.FK_events_guests_zones_events_guests
            : [];
          for (const guestZone of zones) {
            guestZone.FK_events_guests_zones_events_spaces_zones = this.zones.find(z => z.id === guestZone.event_zone_id);
          }
          guest.zoneFilterValues = this.buildGuestZoneFilterValues(zones);
          const existingTags = Array.isArray(guest.Tags) ? guest.Tags : [];
          guest.Tags = [...existingTags];
          if(details.tags) {
            let tagIds = details.tags.split(",").map((id) => parseInt(id, 10));
            tagIds.forEach((tagId) => {
              let tag = this.tags.find(t => t.id === tagId);
              if(tag && !guest.Tags.some(existing => existing.id === tag.id)) {
                guest.Tags.push(tag);
              }
            });
          }
          guest.Tags.forEach(tag => this.guestTagSet.add(tag));
          // Collect mailing IDs from guest
          guest.Mailings = Array.isArray(guest.Mailings) ? guest.Mailings : [];
          guest.Mailings.forEach((mailing) => {
            mailingIds.add(mailing.mailing_id);
          });
          if(this.hasGuestPositionIncident(guest)) {
            guestsWithoutPosition = true;
          }
          guest.relatedGuests = [];
          guest.relatedSearchText = "";
          return guest;
        });

        this.normalizeGuestReferralRelations(this.allGuests);
        this.attachRelatedGuests();
        this.allGuests = this.orderGuestsWithRelated(this.allGuests);
        this.groupFilterOptions = this.getGroupFilterValues();

        // Filter mailings to only those associated with guests
        this.mailings = this.mailings.filter((mailing) => mailingIds.has(mailing.id));

        this.applyMailingFilterFields();

        if(guestsWithoutPosition) {
          this.messageService.add({ severity: 'error', key: 'topright', summary: this.translate.instant('general.error'), detail: this.translate.instant('events.guests.warning_exists_some_incidents') });
        }

        this.guestTags = this.normalizeGuestTags(Array.from(this.guestTagSet));

        // Apply tag filter (this also applies position filter and updates filteredGuests)
        this.applyTagFilter();

        this.initializeGrid();

        this.gridConfig.loading = false;
      }
    });
  }

  private ensureGuestDetails(guest: EventGuest): EventGuestDetails {
    if (guest.details) {
      return guest.details;
    }

    const fallback: EventGuestDetails = {
      id: guest.id ?? 0,
      event_guest_id: guest.id ?? 0,
      guest,
      name: guest.name ?? "",
      surname: guest.surname ?? "",
      lastname: guest.lastname ?? "",
      gender: "",
      imageId: null,
      numIdentification: null,
      personTreatment: null,
      shortPersonTreatment: null,
      positionTreatment: null,
      shortPositionTreatment: null,
      position: guest.position ?? null,
      shortPosition: null,
      institution: null,
      group1Name: null,
      group2Name: null,
      group3Name: null,
      group4Name: null,
      group5Name: null,
      group6Name: null,
      group1Position: null,
      group2Position: null,
      group3Position: null,
      group4Position: null,
      group5Position: null,
      group6Position: null,
      groupColor: null,
      effectivePositionOrder: guest.effective_position_order ?? null,
      groupFullname: "",
      tags: ""
    };

    guest.details = fallback;
    return guest.details;
  }

  private isGuestWithoutAssignedPosition(guest: EventGuest): boolean {
    if (!guest) {
      return false;
    }

    if (guest.person_position_id == null) {
      return true;
    }

    const detailsPosition = guest.details?.position;
    const rawPosition = guest.position;

    return this.isEmptyOrNotPositionLabel(detailsPosition) || this.isEmptyOrNotPositionLabel(rawPosition);
  }

  private hasGuestPositionIncident(guest: EventGuest): boolean {
    
    if (!guest) {
      return false;
    }

    return guest.incidents === true || guest.notPosition === true;

  }

  private isIndividualGuestMode(guest: EventGuest | null | undefined): boolean {
    const mode = this.normalizeGuestMode(guest?.mode);
    return mode === "individual";
  }

  private normalizeGuestMode(mode: unknown): string {
    let normalized = (mode ?? "").toString().trim().toLowerCase();

    // SQL string literals can arrive as N'individual' or 'individual'.
    if (normalized.startsWith("n'") && normalized.endsWith("'")) {
      normalized = normalized.slice(2, -1).trim();
    } else if (normalized.startsWith("'") && normalized.endsWith("'")) {
      normalized = normalized.slice(1, -1).trim();
    }

    return normalized;
  }

  private getGridStateKey(): string {
    const mailingSignature = (this.mailings || [])
      .map(mailing => mailing.id)
      .filter((id): id is number => id != null)
      .sort((a, b) => a - b)
      .join("_") || "none";

    return `${this.gridStateStorageKey}_v3_${this.eventId}_${mailingSignature}`;
  }

  private normalizeGuestTags(tags: Tag[]): Tag[] {
    const tagsById = new Map<number, Tag>();
    for (const tag of tags || []) {
      if (!tag || tag.id == null) {
        continue;
      }
      if (!tagsById.has(tag.id)) {
        tagsById.set(tag.id, tag);
      }
    }

    return Array.from(tagsById.values()).sort((a, b) =>
      (a.title || "").localeCompare(b.title || "")
    );
  }

  private isEmptyOrNotPositionLabel(value: string | null | undefined): boolean {
    const normalized = (value ?? "").toString().trim().toLowerCase();
    if (!normalized) {
      return true;
    }

    return normalized.includes("sin cargo") || normalized.includes("no position") || normalized === "--";
  }

  private buildGuestZoneFilterValues(zones: EventGuestZone[]): SpaceZoneFilterValue[] {
    const values: SpaceZoneFilterValue[] = [];

    zones.forEach(zone => {
      const zoneId = zone.event_zone_id ?? null;
      const placeKey = buildZonePlaceKey(zoneId, zone.file, zone.position);
      const spaceId = this.zoneIdToSpaceId.get(zoneId) ?? null;

      values.push({
        spaceId,
        zoneId,
        placeKey
      });
    });

    return values;

  }

  private loadGuestData() {
    // Los contadores de la barra numérica siempre muestran totales sobre allGuests (no filtrados),
    // igual que la vista legacy. Solo totalIncidents usa filteredGuests para el badge de filtro.
    this.totalGuests = this.allGuests.length;
    this.totalDelegated = this.allGuests.filter(g => g.confirmation_status === 'delegated').length;
    this.totalConfirmed = this.allGuests.filter(g => g.confirmation_status === 'confirmed').length;
    this.totalRejected = this.allGuests.filter(g => g.confirmation_status === 'rejected').length;
    this.totalPending = this.allGuests.filter(g => g.confirmation_status === 'pending').length;
    this.totalPendingApproval = this.allGuests.filter(g => g.confirmation_status === 'pending_approval').length;
    this.totalManageDelegate = this.allGuests.filter(g => g.confirmation_status === 'manage_delegate').length;
    this.totalIncidents = this.filteredGuests.filter(g => this.hasGuestPositionIncident(g)).length;

    const confirmedGuests = this.allGuests.filter(g => g.confirmation_status === 'confirmed');
    const confirmedDelegatedCount = this.allGuests.filter(g => g.confirmation_status === 'delegated').length;
    const confirmedNominalCompanions = confirmedGuests.reduce((sum, g) => {
      return sum + ((g.relatedGuests || []).filter(r => r.referred_option === 'companion').length);
    }, 0);
    const confirmedNotNominalCompanions = confirmedGuests.reduce((sum, g) => {
      const linkedCompanions = (g.relatedGuests || []).filter(r => r.referred_option === 'companion').length;
      const allowedCompanions = g.num_companions || 0;
      return sum + Math.max(0, allowedCompanions - linkedCompanions);
    }, 0);

    // Desglose para tooltip de confirmados (igual que legacy message-popover-totals-confirmed.html)
    const confirmedInvitados = this.totalConfirmed - confirmedNominalCompanions - confirmedNotNominalCompanions - confirmedDelegatedCount;
    const confirmedTooltip =
      this.translate.instant('events.guests.guests') + ': ' + Math.max(0, confirmedInvitados) +
      '<br>' + this.translate.instant('events.guests.nominals') + ': ' + confirmedNominalCompanions +
      '<br>' + this.translate.instant('events.guests.not_nominals') + ': ' + confirmedNotNominalCompanions +
      '<br>' + this.translate.instant('events.guests.delegated') + ': ' + confirmedDelegatedCount;

    // Desglose para tooltip de totales (igual que legacy message-popover-totals-original.html)
    const totalsTooltip =
      this.translate.instant('events.guests.total_confirmed') + ': ' + this.totalConfirmed +
      (this.totalPending > 0 ? '<br>' + this.translate.instant('events.guests.total_pending') + ': ' + this.totalPending : '') +
      (this.totalRejected > 0 ? '<br>' + this.translate.instant('events.guests.total_rejected') + ': ' + this.totalRejected : '') +
      '<br>' + this.translate.instant('events.guests.total_delegated') + ': ' + this.totalDelegated;

    this.numericDataBar = [];
    this.numericDataBar.push({
      label: "events.guests.total_guests",
      value: this.totalGuests,
      tooltip: totalsTooltip,
      callback: this.createStatusFilterCallback(null)
    });

    this.numericDataBar.push({
      label: "events.guests.total_guests_posible",
      value: this.totalGuests,
      tooltip: totalsTooltip
    });

    this.numericDataBar.push({
      label: "events.guests.total_delegated",
      value: this.totalDelegated,
      tooltip: "",
      color: "information",
      callback: this.createStatusFilterCallback(['delegated'])
    });

    this.numericDataBar.push({
      label: "events.guests.total_confirmed",
      value: this.totalConfirmed,
      tooltip: confirmedTooltip,
      color: "primary",
      callback: this.createStatusFilterCallback(['confirmed'])
    });

    this.numericDataBar.push({
      label: "events.guests.total_rejected",
      value: this.totalRejected,
      tooltip: "",
      color: "danger",
      callback: this.createStatusFilterCallback(['rejected'])
    });

    this.numericDataBar.push({
      label: "events.guests.total_pending",
      value: this.totalPending,
      tooltip: "",
      color: "warning",
      callback: this.createStatusFilterCallback(['pending'])
    });

    this.numericDataBar.push({
      label: "events.guests.pending_approval",
      value: this.totalPendingApproval,
      tooltip: "",
      color: "warning-custom",
      callback: this.createStatusFilterCallback(['pending_approval'])
    });

    this.numericDataBar.push({
      label: "events.guests.manage_delegate",
      value: this.totalManageDelegate,
      tooltip: "",
      color: "default-custom",
      callback: this.createStatusFilterCallback(['manage_delegate'])
    });
  }

  private applyMailingFilterFields() {
    if (!this.mailings || this.mailings.length === 0) {
      return;
    }

    this.allGuests.forEach(guest => {
      this.mailings.forEach(mailing => {
        const fieldName = this.getMailingFilterFieldName(mailing.id);
        (guest as any)[fieldName] = this.resolveMailingFilterValue(guest, mailing.id);
      });
    });
  }

  private resolveMailingFilterValue(guest: EventGuest, mailingId: number): string {
    const statusFromMailings = this.resolveMailingStatusFromMailings(guest, mailingId);
    if (statusFromMailings) {
      return statusFromMailings;
    }

    const statusFromGuestList = this.resolveMailingStatusFromGuestList(guest, mailingId);
    if (statusFromGuestList) {
      return statusFromGuestList;
    }

    return "unsent";
  }

  private resolveMailingStatusFromMailings(guest: EventGuest, mailingId: number): string | null {
    const entries = guest?.Mailings?.filter(m => m.mailing_id === mailingId) || [];
    if (entries.length === 0) {
      return null;
    }

    const latest = this.pickLatestMailingStatus(entries);
    const normalizedState = this.normalizeMailingState(latest?.state);

    if (this.isSuccessfulMailingState(normalizedState)) {
      return "sent_success";
    }

    if (this.isErrorMailingState(normalizedState) || this.hasMeaningfulMailingError(latest?.send_error)) {
      return "sent_error";
    }

    return null;
  }

  private resolveMailingStatusFromGuestList(guest: EventGuest, mailingId: number): string | null {
    const entry = this.findMailingGuestListEntry(guest, mailingId);
    if (!entry) {
      return null;
    }

    const normalizedState = this.normalizeMailingState((entry as any)?.status);
    if (this.isSuccessfulMailingState(normalizedState)) {
      return "sent_success";
    }

    if (this.isErrorMailingState(normalizedState)) {
      return "sent_error";
    }

    const normalizedColor = ((entry as any)?.statusNotificationColor ?? "").toString().trim().toLowerCase();
    if (normalizedColor) {
      if (this.isSuccessColor(normalizedColor)) {
        return "sent_success";
      }
      if (this.isErrorColor(normalizedColor)) {
        return "sent_error";
      }
    }

    return null;
  }

  private findMailingGuestListEntry(guest: EventGuest, mailingId: number): MailingGuestList | null {
    const list = guest?.mailings_guests_list;
    if (!list || list.length === 0) {
      return null;
    }

    const byId = list.find((entry: any) => entry?.mailing_id === mailingId);
    if (byId) {
      return byId;
    }

    const referenceMailing = this.mailings.find(mailing => mailing.id === mailingId);
    if (!referenceMailing) {
      return null;
    }

    return list.find((entry: any) => entry?.short_title === referenceMailing.short_title) ?? null;
  }

  private normalizeMailingState(state: string | null | undefined): string | null {
    const normalized = state?.toString().trim().toLowerCase();
    if (!normalized || normalized === "null" || normalized === "undefined") {
      return null;
    }
    return normalized;
  }

  private hasMeaningfulMailingError(rawError: unknown): boolean {
    if (rawError == null) {
      return false;
    }

    const normalized = rawError.toString().trim();
    if (!normalized) {
      return false;
    }

    const lowered = normalized.toLowerCase();
    return lowered !== "null" && lowered !== "undefined" && lowered !== "ok" && lowered !== "success";
  }

  private isSuccessColor(color: string): boolean {
    const tokens = ["#1ab394", "#1ab393", "#198754", "#28a745", "green"];
    return tokens.some(token => color.includes(token.replace('#', '')));
  }

  private isErrorColor(color: string): boolean {
    const tokens = ["#ed5565", "#dc3545", "#c0392b", "#a94442", "red"];
    return tokens.some(token => color.includes(token.replace('#', '')));
  }

  private pickLatestMailingStatus(entries: EventGuestMailing[]): EventGuestMailing {
    return entries.reduce((latest: EventGuestMailing | null, current: EventGuestMailing) => {
      if (!latest) {
        return current;
      }

      const latestTime = latest.real_send_date ? new Date(latest.real_send_date).getTime() : 0;
      const currentTime = current.real_send_date ? new Date(current.real_send_date).getTime() : 0;

      if (currentTime === latestTime) {
        return (current.id ?? 0) > (latest.id ?? 0) ? current : latest;
      }

      return currentTime > latestTime ? current : latest;
    }, null as EventGuestMailing | null) as EventGuestMailing;
  }

  private getMailingFilterFieldName(mailingId: number): string {
    return `mailing_${mailingId}`;
  }

  private isSuccessfulMailingState(state: string | null): boolean {
    if (!state) {
      return false;
    }
    return ["sent", "success", "sent_success", "completed", "delivered", "ok", "done"].includes(state);
  }

  private isErrorMailingState(state: string | null): boolean {
    if (!state) {
      return false;
    }
    return ["error", "failed", "failure", "send_error", "sent_error", "bounce", "rejected", "blocked", "delivery_error"].includes(state);
  }

  private normalizeSpaceZoneFilterValue(filter: FilterMetadata | SpaceZoneFilterValue | null | undefined): SpaceZoneFilterValue | null {
    if (!filter) {
      return null;
    }

    if (this.isFilterMetadata(filter)) {
      return (filter.value as SpaceZoneFilterValue) ?? null;
    }

    return filter as SpaceZoneFilterValue;
  }

  private isFilterMetadata(filter: any): filter is FilterMetadata {
    return !!filter && typeof filter === "object" && Object.prototype.hasOwnProperty.call(filter, "value");
  }

  private matchesZoneCriteria(entry: SpaceZoneFilterValue, criteria: SpaceZoneFilterValue): boolean {
    if (!entry) {
      return false;
    }

    if (criteria.placeKey) {
      return entry.placeKey === criteria.placeKey;
    }

    if (criteria.zoneId !== undefined) {
      return entry.zoneId === criteria.zoneId;
    }

    if (criteria.spaceId !== undefined) {
      return entry.spaceId === criteria.spaceId;
    }

    return true;
  }

  private createStatusFilterCallback(values: string[] | null): () => void {
    return () => {
      if (this.guestListGrid?.table) {
        this.guestListGrid.table.filter(values, 'confirmation_status', 'stringIn');
      }
    };
  }

  private showPrintModal(code: string) {
    if (code === "PROPOSAL_GUEST_LIST" || code === "GUEST_LIST") {
      this.generateDocumentPopup(code, this.guestListGrid.selectedRows);
      return;
    }

    if (this.guestListGrid.selectedRows.length === 0) {
      this.showError = true;
      this.errorMessage = this.translate.instant(_("events.guests.select_persons"));
      return;
    }

    if(code === "PROGRAM_ACTS" && this.guestListGrid.selectedRows.length > 1) {
      this.showError = true;
      this.errorMessage = this.translate.instant(_("events.guests.max_guests_selection"));
      return;
    }

    let guestsGUIDs = this.guestListGrid.selectedRows.map((guest: EventGuest) => guest.guid);

    if (code == "GUEST_ACCREDITATION" || code == "INVITATION" || code == "GUEST_PARKING" || code == "GUEST_LIST_ADDRESSES") {
      let message = '';
      switch(code) {
        case "GUEST_ACCREDITATION":
            message = this.translate.instant(_('events.guests.mark_as_sent_accreditation'));
            break;
        case "GUEST_PARKING":
            message = this.translate.instant(_('events.guests.mark_as_sent_parking'));
            break;
        default:
            message = this.translate.instant(_('events.guests.mark_as_sent_invitation'));
            break;
      }
      this.confirmationService.confirm({
        message: message,
        accept: () => {
          this.eventGuestsService.changeStatusByCodeSend(this.eventId, guestsGUIDs, code).subscribe({
            next: () => {
              this.generateDocumentPopup(code, this.guestListGrid.selectedRows);
              this.loadGuests();
              this.messageService.add({ severity: 'success', key: 'topright', summary: this.translate.instant('general.success'), detail: this.translate.instant('events.guests.mark_as_sent_invitation_success') });
            },
            error: (error) => {
              this.messageService.add({ severity: 'error', key: 'topright', summary: this.translate.instant('general.error'), detail: error.error.message });
            }
          });
        },
        reject: () => {
          this.generateDocumentPopup(code, this.guestListGrid.selectedRows);
          this.messageService.add({ severity: 'warning', key: 'topright', summary: this.translate.instant('general.info'), detail: this.translate.instant('events.guests.mark_as_sent_invitation_cancelled') });  
        }
      }); 
    }

  }

  private generateDocumentPopup(code: string, eventGuests: EventGuest[]) {
    const currentEvent = this.getCurrentEventContext();
    const params = {
      entity_type: "events",
      entity_type_id: currentEvent.id,
      event_guests_id: eventGuests.map(g => g.id),
      mail_account_id: currentEvent.mail_account_id,
      mail_account_reply: currentEvent.reply_to,
      documents: {codes: code}
    };

    this.generateDocumentService.documentNew({
      params: params,
      onAccept: (data) => {
        const document = data[0];
        if(document.document_id !== undefined && document.document_id !== null) {
          
          let generator = new DocumentGenerator(document.document_id);
          generator.event_id = currentEvent.id;
          generator.event_guests_id = params.event_guests_id.join(",");
          if (this.sortOption === "events.spaces.prefered") {
            generator.order = "prefered";
          }
          generator.type = document.type;

          this.documentsService.generateDocument(generator).subscribe({
            next: (result) => {
              this.messageService.add({ severity: 'success', key: 'topright', summary: this.translate.instant('general.success'), detail: this.translate.instant('events.guests.mark_as_sent_invitation_success') });
              this.documentsService.openDocument(result);
            },
            error: (error) => {
              this.messageService.add({ severity: 'error', key: 'topright', summary: this.translate.instant('general.error'), detail: error.error.message });
            }
          });
        }
      }
    });

  }

  public onUpload($event: UploadEvent) {
    this.eventService.goToState("events.edit.guests.import", {
        event_id: this.eventId,
        people: ($event.originalEvent as HttpResponse<any>).body,
        menu_item_id: null
    });
  }
  
  public onUploadError(error:FileUploadErrorEvent) {
    this.messageService.add({ severity: 'error', key: 'center', sticky: true, summary: this.translate.instant('general.error'), detail: error.error.error.error });
  }

  public onUploadUpdate($event: UploadEvent) {
    this.loadGuests();
  } 

  public onUploadUpdateError(error:FileUploadErrorEvent) {
    this.messageService.add({ severity: 'error', key: 'center', summary: this.translate.instant('general.error'), detail: error.error.message });
  }

  private syncGuestDetails(guest: EventGuest) {
    if (!guest?.id) {
      return;
    }

    this.eventGuestsService.syncGuestDetails(this.eventId, guest.id).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', key: 'topright', summary: this.translate.instant('general.success'), detail: this.translate.instant('events.guests.sync_dirty_details_success') });
        this.loadGuests();
      },
      error: (error) => {
        this.log.error('Error syncing guest details', error);
        this.messageService.add({ severity: 'error', key: 'topright', summary: this.translate.instant('general.error'), detail: this.translate.instant('events.guests.sync_dirty_details_error') });
      }
    });
  }

  public syncSelectedGuestDetails() {
    if (!this.guestListGrid || this.guestListGrid.selectedRows.length === 0) {
      this.messageService.add({ severity: 'warn', key: 'topright', summary: this.translate.instant('general.info'), detail: this.translate.instant('events.guests.select_persons') });
      return;
    }

    const dirtyGuestIds = this.guestListGrid.selectedRows
      .filter((guest: EventGuest) => guest.dirtyDetails)
      .map((guest: EventGuest) => guest.id);

    if (dirtyGuestIds.length === 0) {
      this.messageService.add({ severity: 'info', key: 'topright', summary: this.translate.instant('general.info'), detail: this.translate.instant('events.guests.no_dirty_details_selected') });
      return;
    }

    this.eventGuestsService.syncGuestsDetails(this.eventId, dirtyGuestIds).subscribe({
      next: () => {
        this.messageService.add({ severity: 'success', key: 'topright', summary: this.translate.instant('general.success'), detail: this.translate.instant('events.guests.sync_dirty_details_selected_success') });
        this.loadGuests();
      },
      error: (error) => {
        this.log.error('Error syncing dirty guest details', error);
        this.messageService.add({ severity: 'error', key: 'topright', summary: this.translate.instant('general.error'), detail: this.translate.instant('events.guests.sync_dirty_details_selected_error') });
      }
    });
  }

  public onShowOnlyWithoutPositionChange($event: any) {
    this.applyTagFilter();
  }

  public onShowOnlyDirtyDetailsChange($event: any) {
    this.applyTagFilter();
  }

  private getCurrentEventContext(): Event {
    if (this.event) {
      return this.event;
    }

    return {
      id: this.eventId,
      mail_account_id: null,
      reply_to: null
    } as Event;
  }
}
